/* @flow */
import React from 'react';
import Error401 from './Error401';
import Error404 from './Error404';

const Errors = ({errorCode}) => (
  <div style={{textAlign: 'center'}}>
    {errorCode === '401'
      ? <Error401 />
      : errorCode === '404'
          ? <Error404 />
          : <h2>
              Server Error. Please contact site administrator.
            </h2>}
  </div>
);

export default Errors;



// WEBPACK FOOTER //
// ./src/components/Errors/Errors.js